import T from 'prop-types';
import React from 'react';

import { be, bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'CheckboxInput';

const renderCheckboxInput = (props) => {
	const { alignTop, disabled, hasError, label, large, value, ...inputProps } = props;

	return (
		<span className={bm(MODULE_NAME, { large, alignTop })}>
			<label className={be(MODULE_NAME, 'label', { isChecked: value, disabled })}>
				<input
					{...inputProps}
					checked={value}
					className={be(MODULE_NAME, 'input', { error: hasError })}
					disabled={disabled}
					type="checkbox"
					value={value}
				/>
				<span />
				{label}
			</label>
		</span>
	);
};

const CheckboxInput = renderCheckboxInput;

CheckboxInput.propTypes = {
	alignTop: T.bool,
	disabled: T.bool,
	label: T.oneOfType([T.string, T.element]),
	large: T.bool,
	name: T.string.isRequired,
	readOnly: T.bool,
	value: T.bool.isRequired,
};

export default CheckboxInput;
